"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _lodash2 = _interopRequireDefault(require("lodash.flatten"));

var _v = _interopRequireDefault(require("uuid/v4"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Clips = _interopRequireDefault(require("./Clips"));

var _bulkAddTimelineEvent = _interopRequireDefault(require("../../../../../constants/bulkAddTimelineEvent"));

var _ResizableColumnContainer = _interopRequireDefault(require("../../../../../components/ResizableColumnContainer"));

var _getAssetMetaDataField = _interopRequireDefault(require("../../../utils/getAssetMetaDataField"));

var _utils = require("../../../../../utils");

var _SelectedClipTitle = _interopRequireDefault(require("./SelectedClipTitle"));

require("../styles/_basic-builder.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var GRID = 'GRID';
var LIST = 'LIST';
var DURATION_FALLBACK = 2;

var Basic = /*#__PURE__*/function (_Component) {
  _inherits(Basic, _Component);

  var _super = _createSuper(Basic);

  function Basic(_ref) {
    var _this;

    var _videoClips = _ref.videoClips,
        _setCommentFilterClip = _ref.setCommentFilterClip;

    _classCallCheck(this, Basic);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "changeGridView", (0, _lodash.default)(function (view) {
      return function () {
        var clipsView = _this.state.clipsView;

        if (clipsView === view) {
          return;
        }

        _this.setState({
          clipsView: view
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      document.addEventListener(_bulkAddTimelineEvent.default, _this.onAddBulkClipsToTimeline);
    });

    _defineProperty(_assertThisInitialized(_this), "onDragClipOver", (0, _lodash.default)(function (clipId) {
      return function () {
        var videoClips = _this.props.videoClips;
        var emptyClipIndex = _this.state.emptyClipIndex;
        var clipIndex = videoClips.findIndex(function (clip) {
          return clip.clipId === clipId;
        });
        var newEmptyClipIndex = clipIndex === emptyClipIndex ? clipIndex + 1 : clipIndex;

        _this.setState({
          emptyClipIndex: newEmptyClipIndex
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "onSelectClip", (0, _lodash.default)(function (clipId) {
      return function () {
        var _this$props = _this.props,
            videoClips = _this$props.videoClips,
            setCommentFilterClip = _this$props.setCommentFilterClip;
        var selectedClip = videoClips.find(function (clip) {
          return clip.clipId === clipId;
        });

        if (!selectedClip) {
          return;
        }

        setCommentFilterClip(selectedClip);

        _this.setState({
          selectedClip: selectedClip
        });

        if (!_this._playerRef) {
          return;
        }

        _this._playerRef.pauseVideo();

        _this._playerRef.setCustomTime(0);
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "onChangeClipIndex", (0, _lodash.default)(function (clipId) {
      return function (index) {
        var _this$props2 = _this.props,
            onUpdateVideoClips = _this$props2.onUpdateVideoClips,
            videoClips = _this$props2.videoClips;

        var newClips = _toConsumableArray(videoClips);

        var clipIndex = videoClips.findIndex(function (clip) {
          return clip.clipId === clipId;
        });
        var clip = newClips[clipIndex];
        newClips.splice(clipIndex, 1);
        newClips.splice(index, 0, clip);
        onUpdateVideoClips((0, _utils.setBasicClipsStartTimes)(newClips));
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "onRemoveClip", (0, _lodash.default)(function (clipId) {
      var selectedClip = _this.state.selectedClip;
      var _this$props3 = _this.props,
          onUpdateVideoClips = _this$props3.onUpdateVideoClips,
          videoClips = _this$props3.videoClips;

      var newClips = _toConsumableArray(videoClips);

      var clipIndex = videoClips.findIndex(function (clip) {
        return clip.clipId === clipId;
      });
      var removedClipIsSelected = selectedClip && selectedClip.clipId === clipId;
      var newSelectedClip = removedClipIsSelected ? newClips[clipIndex - 1] || newClips[clipIndex + 1] : selectedClip;
      newClips.splice(clipIndex, 1);
      onUpdateVideoClips((0, _utils.setBasicClipsStartTimes)(newClips));

      _this.setState({
        selectedClip: newSelectedClip
      });
    }));

    _defineProperty(_assertThisInitialized(_this), "resetEmptyClipIndex", function () {
      _this.setState({
        emptyClipIndex: void 0
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onClipDrop", function (_ref2) {
      var assetId = _ref2.asset.assetId,
          asset = _ref2.asset;
      var selectedAssets = _this.props.selectedDrawerAssets;
      var assetsToAdd = selectedAssets.some(function (selectedAsset) {
        return selectedAsset.assetId === assetId;
      }) ? selectedAssets : [asset];

      _this.updateClipsFromAssets(assetsToAdd);
    });

    _defineProperty(_assertThisInitialized(_this), "onAddBulkClipsToTimeline", function () {
      var _this$props4 = _this.props,
          selectedDrawerAssets = _this$props4.selectedDrawerAssets,
          videoClips = _this$props4.videoClips;

      _this.updateClipsFromAssets(selectedDrawerAssets, {
        emptyClipIndex: videoClips.length
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getClipsView", function () {
      var clipsView = _this.state.clipsView;
      return (/*#__PURE__*/_react.default.createElement("div", {
          className: "basic-builder__view"
        }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
          onClick: _this.changeGridView(GRID),
          name: "grid",
          color: clipsView === GRID ? 'white' : 'regent',
          size: 20
        }), /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
          onClick: _this.changeGridView(LIST),
          name: "list",
          color: clipsView === LIST ? 'white' : 'regent',
          size: 20
        }))
      );
    });

    _defineProperty(_assertThisInitialized(_this), "setPlayerRef", function (el) {
      if (!el) {
        return;
      }

      _this._playerRef = el;
    });

    _defineProperty(_assertThisInitialized(_this), "getPreview", function () {
      var stateSelectedClip = _this.state.selectedClip;

      var _ref3 = stateSelectedClip || {},
          isImage = _ref3.isImage,
          assetId = _ref3.assetId,
          _ref3$clipId = _ref3.clipId,
          clipId = _ref3$clipId === void 0 ? '' : _ref3$clipId;

      if (!assetId) {
        return (/*#__PURE__*/_react.default.createElement("p", {
            className: "basic-builder__preview-placeholder"
          }, 'Preview your ordered clips when you\'ve chosen some video assets')
        );
      }

      var isTempClipId = clipId.includes('clip-');

      if (!isImage) {
        return (/*#__PURE__*/_react.default.createElement(_commonReact.Player, {
            ref: _this.setPlayerRef,
            assetId: assetId,
            selectedClip: stateSelectedClip,
            showComments: !isTempClipId,
            filterByClipId: true
          })
        );
      }

      return (/*#__PURE__*/_react.default.createElement("div", {
          className: "basic-builder__image-preview"
        }, !isTempClipId ? /*#__PURE__*/_react.default.createElement(_commonReact.CommentsOverlay, {
          selectedClip: stateSelectedClip,
          selector: ".basic-builder__image-preview > .comments-overlay",
          isPlaying: false,
          time: 0,
          totalDuration: 0,
          pauseTime: Function.prototype,
          setCustomTime: Function.prototype,
          filterByClipId: true
        }) : null, /*#__PURE__*/_react.default.createElement(_commonReact.AssetPreview, {
          backgroundPosition: "top",
          assetId: assetId,
          height: "100%",
          width: "100%",
          backgroundSize: "contain",
          hideFileTypeIcon: true,
          darkMode: true,
          borderRadius: 6
        }))
      );
    });

    if (_videoClips.length) {
      _setCommentFilterClip(_videoClips[0]);
    }

    _this.state = {
      selectedClip: _videoClips.length ? _videoClips[0] : void 0,
      clipsView: GRID,
      emptyClipIndex: void 0
    };
    return _this;
  }

  _createClass(Basic, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener(_bulkAddTimelineEvent.default, this.onAddBulkClipsToTimeline);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref4) {
      var prevFilterClip = _ref4.commentFilterClip;
      var commentFilterClip = this.props.commentFilterClip;
      var selectedClip = this.state.selectedClip;

      if (commentFilterClip && commentFilterClip !== prevFilterClip && commentFilterClip !== selectedClip) {
        this.onSelectClip(commentFilterClip.clipId)();
      }
    }
  }, {
    key: "updateClipsFromAssets",
    value: function updateClipsFromAssets(assets) {
      var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state,
          emptyClipIndex = _ref5.emptyClipIndex;

      var _this$props5 = this.props,
          videoClips = _this$props5.videoClips,
          onUpdateVideoClips = _this$props5.onUpdateVideoClips;
      var insertableClips = assets.map(function (asset) {
        var duration = (0, _getAssetMetaDataField.default)('duration', asset, {
          fallback: DURATION_FALLBACK
        });
        return {
          clipId: "clip-".concat((0, _v.default)()),
          assetId: asset.assetId,
          isEmpty: false,
          startTime: 0,
          clipStartTime: 0,
          isImage: (0, _getAssetMetaDataField.default)('type', asset).includes('image'),
          duration: duration,
          originalDuration: duration,
          layerIndex: 1
        };
      });

      var newClips = _toConsumableArray(videoClips);

      newClips.splice(emptyClipIndex === void 0 ? videoClips.length : emptyClipIndex, 0, insertableClips);
      var clipsWithStartTimes = (0, _utils.setBasicClipsStartTimes)((0, _lodash2.default)(newClips));
      onUpdateVideoClips(clipsWithStartTimes);
      this.setState(function (_ref6) {
        var selectedClip = _ref6.selectedClip;
        return {
          selectedClip: selectedClip || clipsWithStartTimes[0],
          emptyClipIndex: void 0
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          stateSelectedClip = _this$state.selectedClip,
          clipsView = _this$state.clipsView,
          emptyClipIndex = _this$state.emptyClipIndex;
      var _this$props6 = this.props,
          videoClips = _this$props6.videoClips,
          canUpdateVideo = _this$props6.canUpdateVideo;

      var _ref7 = stateSelectedClip || {},
          clipId = _ref7.clipId,
          assetId = _ref7.assetId,
          isImage = _ref7.isImage;

      return (/*#__PURE__*/_react.default.createElement("div", {
          className: "basic-builder"
        }, /*#__PURE__*/_react.default.createElement(_ResizableColumnContainer.default, {
          leftProps: {
            title: assetId ? /*#__PURE__*/_react.default.createElement(_SelectedClipTitle.default, {
              assetId: assetId
            }) : void 0,
            icon: isImage ? 'image' : 'video',
            canBeSelected: true
          },
          rightProps: {
            title: "Order Clips (".concat(videoClips.length, ")"),
            icon: 'medialibrary',
            secondaryContent: this.getClipsView()
          },
          className: (0, _classnames.default)({
            'basic-builder__list': clipsView === LIST
          })
        }, this.getPreview(), /*#__PURE__*/_react.default.createElement(_Clips.default, {
          clips: videoClips,
          onSelectClip: this.onSelectClip,
          selectedClipId: clipId,
          onChangeClipIndex: this.onChangeClipIndex,
          clipsView: clipsView,
          onClipDrop: this.onClipDrop,
          onDragOver: this.onDragClipOver,
          emptyClipIndex: emptyClipIndex,
          onRemoveClip: this.onRemoveClip,
          resetEmptyClipIndex: this.resetEmptyClipIndex,
          canUpdateVideo: canUpdateVideo
        })))
      );
    }
  }]);

  return Basic;
}(_react.Component);

exports.default = Basic;